module.exports = __webpack_public_path__ + "img/MariusBuechler_140x140_rund.3dd9461b.jpg";